import React, { useRef, createContext, useContext, type RefObject } from 'react';
import { mergeRefs } from 'use-callback-ref';
import { components, type MenuListComponentProps, type OptionType } from '@atlaskit/select';

const context = createContext<RefObject<HTMLDivElement>>({ current: null });

export const MenuListWithAutoKeyboardScroll = (
	props: MenuListComponentProps<OptionType, false>,
) => {
	const containerRef = useRef<HTMLDivElement>(null);
	const innerRef =
		typeof props.innerRef === 'string' ? props.innerRef : mergeRefs([containerRef, props.innerRef]);

	return (
		<context.Provider value={containerRef}>
			<components.MenuList {...props} innerRef={innerRef} />
		</context.Provider>
	);
};

export const useMenuListRef = () => useContext(context);
